export default "__VITE_ASSET__65fe54d4__"